/**
 * use this helper when you need an id and a label
 * for example, i used it when i worked with months
 * the id was used for the no. of the month and label for the name of it
 * example: id = 1 and label = January
 */
export class IdLabelDto {
    /** used to go through the list, for ex for the months, the id was used as the month no. */
    id: number;
    /** use for the name of the element in the list; i used it for the month name */
    label: string;
}